export const INVENTORY_REQUEST = "INVENTORY_REQUEST";
export const INVENTORY_SUCCESS = "INVENTORY_SUCCESS";
export const INVENTORY_FAILURE = "INVENTORY_FAILURE";
